/**
 * Resolves the single `Platform` the React tree consumes.
 *
 * This module is the only place in the app allowed to ask which environment it
 * is running in; everything downstream just calls the interface.
 */

import type { Platform } from '@shared/types'
import { createElectronPlatform } from './electron-platform'
import { createWebPlatform } from './web-platform'

export async function createPlatform(): Promise<Platform> {
  // Preload attaches `window.jot` over the context bridge. Its absence *is*
  // the web build — there is no build-time flag to read, and there must not be
  // one, or the two targets could drift.
  const bridge = window.jot
  return bridge ? createElectronPlatform(bridge) : createWebPlatform()
}
